import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    CircularProgress,
    Grid,
    IconButton,
    Stack,
    SvgIcon,
    Tooltip,
    Typography,
    useMediaQuery
} from "@mui/material";
import CertifiedBadge from "../CertifiedBadge";
import { SpecialistAvailabilityComponent } from "./SpecialistAvailabilityComponent";
import { Location } from "./Location";
import { ProfileAvatar } from "./ProfileAvatar";
import { Rating } from "./Raiting";
import { ButtonsGroup } from "./ButtonsGroup";
import { roles } from "src/roles";
import { HeaderEditModal } from "src/pages/cabinet/profiles/my/profileHeader/NewHeaderEditModal";
import EditIcon from "@untitled-ui/icons-react/build/esm/Pencil01";
import { LocationEditModal } from "src/pages/cabinet/profiles/my/profileHeader/NewLocationEditModal";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import { SharingProfileMenu } from "src/components/sharing-profile-menu";
import LanguageIcon from '@mui/icons-material/Language';
import Chip from "@mui/material/Chip";
import { useAuth } from 'src/hooks/use-auth';
import { SomeoneFriendshipControls } from './SomeoneFriendshipControls';
import { useDispatch } from 'react-redux';
import { savePrivacyThunk } from 'src/thunks/profilePrivacy';
import { VisibilityIcon } from 'src/pages/components/visibility-icon';
import { tr } from 'src/locales/tr';


function getPageUrl(profile) {
    return process.env.REACT_APP_HOST_P + "/contractors/first1000/" + (profile.profilePage || profile.id);
}

const ProfileHeader = ({
    isOwnProfile,
    profile,
    setProfile,
    handleQrOpen,
    privacySettings
}) => {
    const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
    const { user } = useAuth();
    const dispatch = useDispatch();

    const hasCertificates = profile?.education?.some(edu =>
        edu?.certificates && edu?.certificates?.length > 0
    );

    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [openCommonModal, setOpenCommonModal] = useState(false);
    const [editAvailable, setEditAvailable] = useState(false);

    const canShow = (key) => (isOwnProfile ? true : !!privacySettings[key]);

    const toggle = (key) => () => dispatch(savePrivacyThunk({ [key]: !privacySettings[key] }));

    if (!profile) {
        return <CircularProgress />
    }
    let specialistProfileUrl = getPageUrl(profile.profile);


    return (
        <Stack spacing={2} direction="column">
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <div>

                    <Grid container spacing={3} alignItems="flex-start">
                        <ProfileAvatar profile={profile} setProfile={setProfile} isMyProfile={isOwnProfile} />
                        <Grid item xs>
                            {/* Блок имени и сертификации */}
                            <Box display="flex" alignItems="flex-start" gap={4}>
                                {profile.profile.businessName && canShow('name') && (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography variant="h4" fontWeight="bold">
                                            {profile.profile.businessName}
                                        </Typography>
                                        {/* {isOwnProfile && (
                                            <VisibilityIcon value={privacySettings.name} onToggle={toggle('name')} />
                                        )} */}
                                    </Stack>
                                )}
                                <Stack direction="row" spacing={1}>
                                    <Tooltip title={tr("QR business card")}>
                                        <IconButton onClick={handleQrOpen}>
                                            <SvgIcon>
                                                <QrCode2Icon />
                                            </SvgIcon>
                                        </IconButton>
                                    </Tooltip>
                                    <SharingProfileMenu url={specialistProfileUrl}
                                        user={profile?.profile} />
                                </Stack>
                            </Box>

                            {profile.profile.email && canShow('email') && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography color="text.secondary">{profile.profile.email}</Typography>
                                    {/* {isOwnProfile && (
                                        <VisibilityIcon value={privacySettings.email} onToggle={toggle('email')} />
                                    )} */}
                                </Stack>
                            )}

                            {profile.profile.phone && canShow('phone') && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography color="text.secondary">{profile.profile.phone}</Typography>
                                    {/* {isOwnProfile && (
                                        <VisibilityIcon value={privacySettings.phone} onToggle={toggle('phone')} />
                                    )} */}
                                </Stack>
                            )}

                            {profile.profile.address?.location && canShow('location') && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography color="text.secondary">
                                        {profile.profile.address.location.place_name}
                                    </Typography>
                                    {/* {isOwnProfile && (
                                        <VisibilityIcon value={privacySettings.location} onToggle={toggle('location')} />
                                    )} */}
                                </Stack>
                            )}

                            {/* Блок рейтинга */}

                            {profile?.profile?.role === roles.WORKER && <div>
                                <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.5, flexWrap: 'wrap', gap: 0.5 }}>
                                    <LanguageIcon fontSize="small" color="action" />
                                    {profile?.profile?.languages?.map((lang, index) => (
                                        <Chip
                                            key={index}
                                            label={lang}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                                height: '20px',
                                                fontSize: '0.75rem',
                                                color: 'text.secondary',
                                                borderColor: 'action.selected'
                                            }}
                                        />
                                    )) || tr("Not set")}
                                </Stack>
                                <Rating profile={profile?.profile} />
                                <Location profile={profile} onEdit={isOwnProfile ? () => {
                                    setOpenAddressModal(true)
                                } : null} />
                                <SpecialistAvailabilityComponent profile={profile} setProfile={setProfile}
                                    isOwnProfile={isOwnProfile}
                                    editMode={editAvailable} />
                            </div>}

                            <ButtonsGroup profile={profile} setProfile={setProfile} isOwnProfile={isOwnProfile} />
                        </Grid>
                    </Grid>

                </div>
                {isOwnProfile ? (
                    <IconButton cursor="pointer" onClick={() => {
                        setOpenCommonModal(true)
                    }}>
                        <Tooltip title={tr("Edit common information")}>
                            <SvgIcon fontSize="small">
                                <EditIcon />
                            </SvgIcon>
                        </Tooltip>
                    </IconButton>
                ) : (
                    <SomeoneFriendshipControls profile={profile} setProfile={setProfile} />
                )}
                <HeaderEditModal profile={profile.profile} setProfile={setProfile} open={openCommonModal}
                    onClose={setOpenCommonModal} />
                <LocationEditModal profile={profile.profile} setProfile={setProfile} open={openAddressModal}
                    onClose={setOpenAddressModal} />
            </Stack>
            {profile?.profile?.role === roles.WORKER && hasCertificates &&
                <CertifiedBadge />}
        </Stack>
    );
};

ProfileHeader.propTypes = {
    isOwnProfile: PropTypes.bool,
    profile: PropTypes.shape({
        name: PropTypes.string,
        avatar: PropTypes.string,
        rating: PropTypes.string,
        reviewsCount: PropTypes.number,
        address: PropTypes.shape({
            location: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            duration: PropTypes.string,
            zipCode: PropTypes.string,
        }),
        isCertified: PropTypes.bool
    }),
    handleSave: PropTypes.func,
    setProfile: PropTypes.func,
};

export default memo(ProfileHeader);